import { render, staticRenderFns } from "./FullEventsCalendar.vue?vue&type=template&id=5ecf3dd6&scoped=true&"
import script from "./FullEventsCalendar.vue?vue&type=script&lang=js&"
export * from "./FullEventsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./FullEventsCalendar.vue?vue&type=style&index=0&id=5ecf3dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf3dd6",
  null
  
)

export default component.exports